export enum  WorkingStatus{

    WORKING = 'WORKING' ,

    NOT_WORKING = 'NOT_WORKING' ,

    STUDENTS = 'STUDENTS'
}